import { Tab, Tabs } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './Tabs.scss';

interface AppTabsProps {
  value: string;
  options: Option[];
  onChangeValue: (value: string) => void;
}

const AppTabs: FC<AppTabsProps> = ({ value, options, onChangeValue }) => {
  const { t } = useTranslation();

  return (
    <Tabs
      className="Tabs"
      value={value}
      onChange={(_, value) => onChangeValue(value)}
      TabIndicatorProps={{ hidden: true }}
    >
      {options.map(({ value, label }) => (
        <Tab key={value} value={value} label={t(label)} />
      ))}
    </Tabs>
  );
};

export default AppTabs;
